import type { Embedding } from './search.types';

export function cosineSimilarity(a: Embedding, b: Embedding) {
  if (a.length !== b.length) {
    throw new Error(`Embeddings must be the same length: ${a.length} !== ${b.length}`);
  }

  let dot = 0.0;
  let normA = 0.0;
  let normB = 0.0;

  for (let i = 0; i < a.length; i++) {
    dot += a[i] * b[i];
    normA += a[i] * a[i];
    normB += b[i] * b[i];
  }

  return dot / (Math.sqrt(normA) * Math.sqrt(normB));
}
